import { useState } from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const BukIntegrationForm = ({
  bukUrl,
  bukApiToken,
  rut,
  handleFieldChange,
  fieldErrors,
  error,
  urlPlaceholder = "https://miempresa.starter.buk.cl",
  tokenPlaceholder = "Token de acceso de Buk",
  rutLabel = "RUT de la empresa en Buk",
  rutPlaceholder = "12345678-9",
  descriptionText
}) => {
  const [showToken, setShowToken] = useState(false);

  const handleClickShowToken = () => setShowToken((show) => !show);

  const handleMouseDownToken = (event) => {
    event.preventDefault();
  };

  return (
    <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
      <div className="space-y-4 text-gray-700">
        <div className="flex items-start gap-3">
          <span className="text-xl font-bold text-primary">3.</span>
          <div className="flex-1 space-y-4">
            {descriptionText && (
              <p className="mb-4">
                {descriptionText}
              </p>
            )}
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
                {error}
              </div>
            )}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                URL de la empresa en Buk <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={bukUrl}
                onChange={(e) => handleFieldChange('bukUrl', e.target.value)}
                placeholder={urlPlaceholder}
                className={`mt-1 block w-full rounded-xl border px-4 py-2 shadow-sm focus:ring-primary sm:text-sm ${fieldErrors.bukUrl ? 'border-red-500 focus:border-red-500' : 'border-gray-300 focus:border-primary'
                  }`}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Buk API Token <span className="text-red-500">*</span>
              </label>
              <div className="relative">
              <input
                type={showToken ? 'text' : 'password'}
                value={bukApiToken}
                onChange={(e) => handleFieldChange('bukApiToken', e.target.value)}
                placeholder={tokenPlaceholder}
                className={`mt-1 block w-full rounded-xl border px-4 py-2 pr-10 shadow-sm focus:ring-primary sm:text-sm ${fieldErrors.bukApiToken ? 'border-red-500 focus:border-red-500' : 'border-gray-300 focus:border-primary'
                    }`}
                />
                <button
                  type="button"
                  aria-label="toggle token visibility"
                  onClick={handleClickShowToken}
                  onMouseDown={handleMouseDownToken}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
                >
                  {showToken ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                </button>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {rutLabel} <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={rut}
                onChange={(e) => handleFieldChange('rut', e.target.value)}
                placeholder={rutPlaceholder}
                className={`mt-1 block w-full rounded-xl border px-4 py-2 shadow-sm focus:ring-primary sm:text-sm ${fieldErrors.rut ? 'border-red-500 focus:border-red-500' : 'border-gray-300 focus:border-primary'
                }`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BukIntegrationForm;

